// Theme types
export var Mode;

(function (Mode) {
  Mode["Light"] = "light";
  Mode["Dark"] = "dark";
})(Mode || (Mode = {}));

export var Theme; // Color types

(function (Theme) {
  Theme["Rise"] = "rise";
  Theme["Accessible"] = "accessible";
})(Theme || (Theme = {}));